/* eslint-disable no-restricted-globals */
import React, { useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Card, CardBody, CardTitle,
} from 'reactstrap';
import moment from 'moment';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import { Can } from '../../utilities/Can';
import BaseGrid from '../../components/Common/BaseGrid';
import { get, del } from '../../helpers/api_helper';

function TVs(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const { t } = props;

  const [signal, setSignal] = useState(0);

  const print = async (obj) => {
    try {
      await get(`/api/tvs/print/${obj.id}`);
    } catch (error) {
      toastr.error('Error printing TV label', 'Error');
    }
  };

  const deleteTv = async (obj) => {
    // eslint-disable-next-line no-alert
    if (confirm(t('Are you sure you want to delete this TV?'))) {
      try {
        await del(`/api/tvs/${obj.id}`);
        setSignal(signal + 1);
      } catch (error) {
        toastr.error(error.message, 'Error');
      }
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col xxl="12">
            <Card>
              <CardBody>
                <CardTitle className="h4">{t('TVs')}</CardTitle>

                <Can i="see" this="TVs">
                  <BaseGrid
                    url="/api/tvs"
                    hasSearch
                    shouldUpdate={signal}
                    config={
                    {
                      columns: {
                        id: {
                          label: 'ID',
                          sort: true,
                        },
                        user: {
                          label: 'User',
                          sort: true,
                          format: (value) => (value ? value.display_name : ''),
                        },
                        sjn: {
                          label: 'SJN',
                          sort: true,
                        },
                        classification: {
                          label: 'Classification',
                          sort: true,
                          style: { textTransform: 'capitalize', fontSize: '19px', fontWeight: 'bold' },
                        },
                        truck: {
                          label: 'Origin',
                          sort: true,
                          html: true,
                          format: (value) => {
                            if (value) {
                              return `${value.supplier ? `${value.supplier.name}:` : ''} <a href="/sourcing/truck/${value.id}">${value.reference}</a>`;
                            }
                            return '--';
                          },
                        },
                        brand: {
                          label: 'Brand',
                          sort: true,
                        },
                        model: {
                          label: 'Model',
                          sort: true,
                        },
                        device: {
                          label: 'Device',
                          sort: false,
                          html: true,
                          format: (value) => {
                            let text = '';
                            if (value !== null) {
                              text += value.marketing_title;
                              text += '<br />';
                            }

                            text += value ? value.id : '';

                            return text;
                          },
                        },
                        serial: {
                          label: 'Serial',
                          sort: true,
                        },
                        created_at: {
                          label: 'Created',
                          date: {
                            format: (date) => (moment(date).fromNow()),
                            timezone: process.env.LOCAL_TZ,
                          },
                        },
                        actions: {
                          label: props.t('Actions'),
                          actions: [
                            {
                              key: 'print',
                              icon: 'bx bx-printer',
                              class: 'btn btn-sm btn-soft-dark',
                              alt: props.t('Print'),
                              click: print,
                            },
                            {
                              key: 'delete',
                              icon: 'mdi mdi-trash-can',
                              class: 'btn btn-sm btn-soft-danger',
                              alt: props.t('Delete'),
                              click: deleteTv,
                            },
                          ],
                        },
                      },
                      pagination: {
                        sort: 'id',
                        direction: 'desc',
                        perPage: 10,
                      },
                    }
                    }
                  />
                </Can>

                <Can not i="see" this="TVs"><p>{t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}

TVs.defaultProps = {
  t: (x) => (x),
};

TVs.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(TVs));
